export const ADMIN_HOMEPAGE_CONTENT_PATH = "/admin/contents/homepage" as const;

export const LEGACY_ADMIN_HOMEPAGE_CONTENT_PATHS = [
  "/admin/content/homepage",
  "/admin/homepage",
  "/admin/website",
] as const;

export function isLegacyAdminHomepageContentPath(pathname: string) {
  const normalized =
    pathname.length > 1 ? pathname.replace(/\/+$/u, "") : pathname;
  return LEGACY_ADMIN_HOMEPAGE_CONTENT_PATHS.some(
    (legacyPath) => legacyPath === normalized,
  );
}
